const CHAT_SCRIPT_URL = 'https://chat.apps.deolanebeauty.com.br/widget.js';

let chatLoadStarted = false;

function loadChat() {
  if (chatLoadStarted || document.querySelector(`script[src="${CHAT_SCRIPT_URL}"]`)) return;

  chatLoadStarted = true;
  const script = document.createElement('script');
  script.src = CHAT_SCRIPT_URL;
  script.defer = true;
  script.dataset.deobeautyChat = 'true';
  document.body.append(script);
}

const interactionEvents = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
for (const eventName of interactionEvents) {
  window.addEventListener(eventName, loadChat, { once: true, passive: true });
}

window.setTimeout(loadChat, 5000);
